import Cookies from 'js-cookie';
import apiSlice from './apiSlice';

const apiSliceWithTag = apiSlice.enhanceEndpoints({ addTagTypes: ['Organizations', 'Users'] });

const fetchOrganizations = apiSliceWithTag.injectEndpoints({
  endpoints: (builder) => ({
    fetchOrganizations: builder.query({
      query: () => ({
        url: '/organizations/',
        method: 'GET',
        headers: {
          'X-CSRFToken': Cookies.get('csrftoken'),
        },
      }),
      providesTags: ['Organizations'],
    }),
    createOrganization: builder.mutation({
      query: ({ payload }) => ({
        url: `/organizations/`,
        method: 'POST',
        body: payload,
        headers: {
          'Content-Type': 'application/json',
          'X-CSRFToken': Cookies.get('csrftoken'),
        },
      }),
      invalidatesTags: ['Organizations'],
    }),
    destroyOrganization: builder.mutation({
      query: (id) => ({
        url: `/organizations/${id}`,
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRFToken': Cookies.get('csrftoken'),
        },
      }),
      invalidatesTags: ['Organizations'],
    }),
    updateOrganization: builder.mutation({
      query: ({ id, payload }) => ({
        url: `/organizations/${id}`,
        method: 'PUT',
        body: payload,
        headers: {
          'Content-Type': 'application/json',
          'X-CSRFToken': Cookies.get('csrftoken'),
        },
      }),
      invalidatesTags: ['Organizations'],
    }),
    getOrganization: builder.query({
      query: (id) => ({
        url: `/organizations/${id}`,
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRFToken': Cookies.get('csrftoken'),
        },
      }),
      invalidatesTags: ['Organizations'],
    }),
    getOrganizationUser: builder.query({
      query: (opk) => ({
        url: `/organizations/${opk}/users/`,
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRFToken': Cookies.get('csrftoken'),
        },
      }),
      invalidatesTags: ['Organizations'],
      providesTags: ['Users'],
    }),
    createOrganizationUser: builder.mutation({
      query: ({ payload, opk, orgurl, invurl }) => ({
        url: `/organizations/${opk}/users/`,
        method: 'POST',
        body: payload,
        headers: {
          'Content-Type': 'application/json',
          'X-CSRFToken': Cookies.get('csrftoken'),
        },
        params: {
          organization_url_template: orgurl,
          invitation_url_template: invurl,
        },
      }),
      invalidatesTags: ['Organizations'],
    }),
    destroyOrganizationUser: builder.mutation({
      query: ({ opk, id }) => ({
        url: `/organizations/${opk}/users/${id}`,
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRFToken': Cookies.get('csrftoken'),
        },
      }),
      invalidatesTags: ['Organizations', 'Users'],
    }),
    getOneOrganizationUser: builder.query({
      query: ({ opk, id }) => ({
        url: `/organizations/${opk}/users/${id}`,
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRFToken': Cookies.get('csrftoken'),
        },
      }),
      invalidatesTags: ['Organizations'],
    }),
    editOneOrganizationUser: builder.mutation({
      query: ({ opk, id, payload }) => ({
        url: `/organizations/${opk}/users/${id}`,
        method: 'PUT',
        body: payload,
        headers: {
          'Content-Type': 'application/json',
          'X-CSRFToken': Cookies.get('csrftoken'),
        },
      }),
      invalidatesTags: ['Organizations', 'Users'],
    }),
    setOwner: builder.mutation({
      query: ({ opk, id }) => ({
        url: `/organizations/${opk}/users/${id}/set_owner/`,
        method: 'GET',
        headers: {
          'X-CSRFToken': Cookies.get('csrftoken'),
        },
      }),
      invalidatesTags: ['Organizations', 'Users'],
    }),
  }),
});

export const {
  useFetchOrganizationsQuery,
  useCreateOrganizationMutation,
  useDestroyOrganizationMutation,
  useUpdateOrganizationMutation,
  useGetOrganizationQuery,
  useCreateOrganizationUserMutation,
  useDestroyOrganizationUserMutation,
  useGetOrganizationUserQuery,
  useGetOneOrganizationUserQuery,
  useEditOneOrganizationUserMutation,
  useSetOwnerMutation,
} = fetchOrganizations;

export default fetchOrganizations;
